export function PageSkeleton() {
  return (
    <div className="mx-auto max-w-6xl space-y-4" data-testid="page-loading">
      <div className="h-8 w-64 animate-pulse rounded-xl bg-slate-200/70" />
      <div className="h-40 animate-pulse rounded-3xl bg-slate-200/60" />
      <div className="h-64 animate-pulse rounded-3xl bg-slate-200/50" />
    </div>
  );
}
